import { convertLinkToBackEnd } from '@/src/utils/url'

import { Api } from '../AApi'

export const API_WORKSPACE = new Api({ url: 'workspaces' })

export const API_STYLE = new Api(
  { url: 'styles' },
  {
    download: {
      type: 'getDetail',
      request(id) {
        return this.sdk.get(`styles/${id}/download`).then((res) => {
          if (res.data.data) {
            window.location = convertLinkToBackEnd(
              `/api/download/${res.data.data}`
            )
          }
          return res
        })
      },
    },
  }
)

export const API_KEY = new Api({ url: 'key-apis' })
